import { m } from 'framer-motion';

import Badge from '@mui/material/Badge';
import SvgIcon from '@mui/material/SvgIcon';
import IconButton from '@mui/material/IconButton';

import { useSettingsContext } from 'src/components/settings';
import { varTap, varHover, transitionTap } from 'src/components/animate';

// ----------------------------------------------------------------------

export function SettingsButton({ sx, ...other }) {
  const settings = useSettingsContext();

  return (
    <IconButton
      component={m.button}
      whileTap={varTap(0.96)}
      whileHover={varHover(1.04)}
      transition={transitionTap()}
      aria-label="Settings button"
      onClick={settings.onToggleDrawer}
      sx={[{ p: 0, width: 40, height: 40 }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...other}
    >
      <Badge color="error" variant="dot" invisible={!settings.canReset}>
        <SvgIcon
          component={m.svg}
          animate={{ rotate: 360 }}
          transition={{ duration: 8, ease: 'linear', repeat: Infinity }}
        >
          <path
            opacity="0.5"
            fill="currentColor"
            d="M14.28 2.15C13.9 2 13.44 2 12.5 2s-1.4 0-1.78.15a2 2 0 0 0-1.09 1.09c-.1.22-.13.48-.14.86a1.6 1.6 0 0 1-.8 1.35 1.6 1.6 0 0 1-1.58 0 3 3 0 0 0-.82-.3 2 2 0 0 0-1.5.4c-.31.24-.55.64-1.02 1.45s-.7 1.21-.75 1.6a2 2 0 0 0 1.08 2.04c.47.3.78.8.78 1.36s-.3 1.06-.78 1.36q-.48.28-.68.56a2 2 0 0 0-.4 1.48c.05.39.28.8.75 1.6s.7 1.21 1.03 1.45c.42.33.96.47 1.49.4.24-.03.48-.13.82-.3a1.6 1.6 0 0 1 1.58 0c.49.28.78.8.8 1.35.01.38.05.64.14.87a2 2 0 0 0 1.1 1.08c.36.15.83.15 1.77.15s1.4 0 1.78-.15a2 2 0 0 0 1.09-1.09q.14-.31.14-.86a1.6 1.6 0 0 1 .8-1.35 1.6 1.6 0 0 1 1.58 0c.34.17.58.27.82.3.53.07 1.07-.07 1.5-.4.31-.24.55-.64 1.02-1.45s.7-1.21.75-1.6a2 2 0 0 0-.4-1.48c-.14-.2-.35-.36-.68-.56-.47-.3-.78-.8-.78-1.36s.3-1.06.78-1.36c.33-.2.54-.36.68-.56a2 2 0 0 0 .4-1.48c-.05-.39-.28-.8-.75-1.6s-.7-1.21-1.03-1.45a2 2 0 0 0-1.49-.4 3 3 0 0 0-.82.3 1.6 1.6 0 0 1-1.58 0 1.6 1.6 0 0 1-.8-1.35 2 2 0 0 0-.14-.86 2 2 0 0 0-1.1-1.09"
          />
          <path fill="currentColor" d="M15.52 12a3 3 0 0 1-3.02 3 3 3 0 1 1 0-6 3 3 0 0 1 3.02 3" />
        </SvgIcon>
      </Badge>
    </IconButton>
  );
}
